import { createFileRoute } from '@tanstack/react-router'
import successSvg from '@/assets/success.svg'
import { StatusScreen } from '@/components/ui/status-screen'

export const Route = createFileRoute('/payment-status/success')({
  component: SuccessPage,
})

function SuccessPage() {
  return (
    <StatusScreen
      image={successSvg}
      alt="Success"
      title="Оплата прошла успешно!"
      description="Спасибо, что выбираете нас."
      buttonContent={'Вернуться на главную'}
      linkProps={{ to: '/' }}
    />
  )
}
